"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandshakeRpcRemote = exports.INTERLEAVE_REQUEST_TIMEOUT = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const logger = new utils_1.Logger(module);
exports.INTERLEAVE_REQUEST_TIMEOUT = 10000;
class HandshakeRpcRemote extends dht_1.RpcRemote {
    async handshake(streamPartId, neighborNodeIds, concurrentHandshakeNodeId, interleaveNodeId) {
        const request = {
            streamPartId,
            requestId: (0, uuid_1.v4)(),
            neighborNodeIds: neighborNodeIds.map((id) => (0, dht_1.toDhtAddressRaw)(id)),
            concurrentHandshakeNodeId: (concurrentHandshakeNodeId !== undefined) ? (0, dht_1.toDhtAddressRaw)(concurrentHandshakeNodeId) : undefined,
            interleaveNodeId: (interleaveNodeId !== undefined) ? (0, dht_1.toDhtAddressRaw)(interleaveNodeId) : undefined
        };
        try {
            const response = await this.getClient().handshake(request, this.formDhtRpcOptions());
            return {
                accepted: response.accepted,
                interleaveTargetDescriptor: response.interleaveTargetDescriptor
            };
        }
        catch (err) {
            logger.debug(`handshake to ${(0, dht_1.toNodeId)(this.getPeerDescriptor())} failed`, { err });
            return {
                accepted: false
            };
        }
    }
    async interleaveRequest(originatorDescriptor) {
        const request = {
            interleaveTargetDescriptor: originatorDescriptor
        };
        const options = this.formDhtRpcOptions({
            connect: false,
            timeout: exports.INTERLEAVE_REQUEST_TIMEOUT
        });
        try {
            const res = await this.getClient().interleaveRequest(request, options);
            return {
                accepted: res.accepted
            };
        }
        catch (err) {
            logger.debug(`interleaveRequest to ${(0, dht_1.toNodeId)(this.getPeerDescriptor())} failed`, { err });
            return {
                accepted: false
            };
        }
    }
}
exports.HandshakeRpcRemote = HandshakeRpcRemote;
//# sourceMappingURL=HandshakeRpcRemote.js.map